import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("carivisor_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Immediately sign out & bounce to login if an admin deactivated this account.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (
      err?.response?.status === 401 &&
      typeof detail === "string" &&
      detail.toLowerCase().includes("deactivat")
    ) {
      localStorage.removeItem("carivisor_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login?deactivated=1";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Absolutize a stored file path ("/api/files/...") into a fully-qualified URL.
export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path.startsWith("/") ? "" : "/"}${path}`;
}

// Upload a File object to object storage; returns { url, id }.
export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

// Upload a base64 data URL (signature pad); returns { url }.
export async function uploadDataUrl(dataUrl) {
  const { data } = await api.post("/upload/data-url", { data_url: dataUrl });
  return data;
}
